import { render } from "./TrainingFile.vue?vue&type=template&id=4eb07906&scoped=true"
import script from "./TrainingFile.vue?vue&type=script&lang=js"
export * from "./TrainingFile.vue?vue&type=script&lang=js"

import "./TrainingFile.vue?vue&type=style&index=0&id=4eb07906&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eb07906"]])

export default __exports__